module.exports = __webpack_public_path__ + "static/media/whatsapp.55d60cd7.svg";